import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const AdminLogin = ({ credentials, setCredentials, onLogin, isLoggingIn }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img 
            src="/logo-new.png" 
            alt="The Pillar Project Logo" 
            className="w-20 h-20 object-contain mx-auto mb-4"
          />
          <h1 className="text-2xl font-semibold text-gray-900" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>
            Admin Dashboard
          </h1>
          <p className="text-gray-600 mt-2">The Pillar Project Corporation</p>
        </div>

        <form onSubmit={onLogin} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
          <div className="mb-6">
            <Label htmlFor="username" className="text-sm font-medium text-gray-700 mb-2 block">
              Username
            </Label>
            <Input
              id="username"
              data-testid="admin-username-input"
              required
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="rounded-xl border-gray-200"
              placeholder="Enter username"
            />
          </div>

          <div className="mb-6">
            <Label htmlFor="password" className="text-sm font-medium text-gray-700 mb-2 block">
              Password
            </Label>
            <Input
              id="password"
              type="password"
              data-testid="admin-password-input"
              required
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="rounded-xl border-gray-200"
              placeholder="Enter password"
            />
          </div>

          <Button
            type="submit"
            data-testid="admin-login-btn"
            disabled={isLoggingIn}
            className="w-full bg-warm-700 hover:bg-warm-800 text-white rounded-full py-6"
          >
            {isLoggingIn ? "Logging in..." : "Login"}
          </Button>

          <Link 
            to="/" 
            className="block text-center mt-4 text-sm text-gray-600 hover:text-warm-700 transition-colors"
          >
            &larr; Back to Website
          </Link>
        </form>
      </div>
    </div>
  );
};
